import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

// simple reusable modal to show a user's selfie and nickname, auto-closes
export default function UserProfileModal({ user, onClose }) {
    useEffect(() => {
        if (!user) return;
        const timer = setTimeout(() => {
            onClose();
        }, 2000);
        return () => clearTimeout(timer);
    }, [user, onClose]);

    if (!user) return null;

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 2000
            }}
            onClick={onClose}
        >
            <motion.div
                initial={{ scale: 0.7 }}
                animate={{ scale: 1 }}
                exit={{ scale: 0.7 }}
                transition={{ type: 'spring', stiffness: 300, damping: 20 }}
                style={{
                    background: '#fff',
                    borderRadius: '50%',
                    padding: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    maxWidth: '90vw',
                    maxHeight: '90vh'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <img
                    src={user.selfie_path || ''}
                    alt={user.nickname}
                    style={{
                        width: '80vw',
                        maxWidth: '300px',
                        height: '80vw',
                        maxHeight: '300px',
                        borderRadius: '50%',
                        objectFit: 'cover'
                    }}
                />
                <div style={{ marginTop: '10px', fontWeight: '600' }}>{user.nickname}</div>
            </motion.div>
        </motion.div>
    );
}
